import { useState, useCallback } from 'react';
import { pwp254Api, FP610 } from '../../../services/pwp254Api';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for master */
  const resolveAllNames = useCallback(async (data: Partial<FP610>) => {
    const entries: [string, string, string][] = [
      ['customer', 'customer', data.fp610_25 || ''],
      ['product', 'product', data.fp610_29 || ''],
      ['operator', 'employee', data.fp610_91 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        pwp254Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await pwp254Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, setNames, resolveAllNames, resolveSingleName, clearNames };
}
